import { Divider } from '@mui/material';

import LabelFilter from './LabelFilter';
import PriorityFilter from './PriorityFilter';
import TaskRangeFilter from './TaskRangeFilter';
import './TaskSideBar.scss';
import { TodoList } from '../TodoList';

const TaskSideBar = () => {
  return (
    <div className="task-side-bar">
      <TaskRangeFilter />
      <Divider />
      <LabelFilter />
      <Divider />
      <PriorityFilter />
      <Divider />
      <TodoList className="sidebar__todos" />

    </div>
  );
};

export default TaskSideBar;
